import React, { useState } from 'react'
import { StaticImage } from 'gatsby-plugin-image'
// import Image from '../../function/Image'
import parse from 'html-react-parser'
function Video({ videoPreview }) {
    const [isOpen, setIsOpen] = useState(true)
    return (
        <div>
            <div className=" z-10 relative mb-14">
                <div className="xl:col-span-3 whitespace-pre-wrap flex flex-col justify-center mb-10 xl:mb-0 text-center xl:text-left">
                    {videoPreview?.textSection &&
                        parse(videoPreview?.textSection)}
                </div>
                {isOpen ? (
                    <div
                        className="col-span-12 lg:col-start-5 lg:col-span-8 aspect-[816/481] rounded-[10px] bg-gradient-to-tr from-white to-[#6A86B3] grid place-items-center relative "
                        onClick={() => {
                            setIsOpen(false)
                        }}
                    >
                        <div className="!absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 h-[50px] aspect-[240/97] lg:h-[97px]">
                            {/* <Image {...videoPreview?.video?.thumbnail} /> */}
                        </div>
                        <div className="rounded-full py-[23px] pl-7 pr-[23px] bg-black/20 cursor-pointer">
                            <StaticImage
                                src="../../images/Play.png"
                                className="w-5"
                            />
                        </div>
                    </div>
                ) : (
                    <div className="video col-span-12 lg:col-start-5 lg:col-span-8 aspect-[816/481] rounded-[10px] overflow-hidden">
                        <iframe
                            width="560"
                            height="315"
                            src={videoPreview?.video.videoLink}
                            title="YouTube video player"
                            frameborder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                            allowfullscreen
                        ></iframe>
                    </div>
                )}
            </div>
        </div>
    )
}

export default Video
